import type { Step } from "react-joyride";

export const leaveRequestFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ໃຊ້ສົ່ງຄຳຂໍລາພັກໃໝ່. ເລືອກພະນັກງານ, ປະເພດລາ, ວັນເລີ່ມ–ສິ້ນສຸດ ເຫດຜົນ. ວັນລາຄິດອັດຕະໂນມັດ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="leave-request-form-back"]',
    content: "ກັບໄປລາຍການອະນຸມັດລາ. ກົດປຸ່ມວົງມົນເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-request-form-form"]',
    content: "ເລືອກພະນັກງານ, ປະເພດລາ, ວັນເລີ່ມ–ສິ້ນສຸດ ແລະ ເຫດຜົນ. ກົດສົ່ງຄຳຂໍເມື່ອຕື່ມຄົບ.",
    placement: "top",
  },
];
